import openVideo from '../modules/openVideo';

openVideo();